import api, { apiPrefix } from './Api';
import { Page, pageFromResponse } from '../interfaces/Page/Page';

const pageApiPrefix = `${apiPrefix}/page`;

export const getPage = async (slug: string): Promise<Page> => {
  const response = await api.get(`${pageApiPrefix}/${slug}`);

  return pageFromResponse(response.data?.data);
};
